// Nel browser `process` non esiste. Bun inlinea i riferimenti letterali
// `process.env.PUBLIC_*` (bunfig [serve.static]/[build] env = "PUBLIC_*") solo
// per le variabili presenti nell'ambiente al build: una variabile assente
// (es. ARG Docker non passato) resta un riferimento letterale e l'app crasha
// con "ReferenceError: process is not defined". Questo polyfill — importato
// come PRIMO modulo in index.tsx, prima di config/env.ts — rende `process`
// disponibile con env vuoto, così ogni lettura non inlineata degrada a
// `undefined` invece di far crashare l'app (config/env.ts e le sue validator
// gestiscono già undefined).
const globalScope = globalThis as {
  process?: { env?: Record<string, string | undefined> };
};

globalScope.process ??= { env: {} };
